import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function CircularProgressWithLabel(props) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
      }}
    >
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          variant="determinate"
          {...props}
          sx={{
            color: "#30CC45",
          }}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#00000025",
            borderRadius: "50%",
          }}
        >
          <Typography variant="caption" component="div" sx={{ color: "#FFFFFF" }}>
            {`${props.value}%`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default CircularProgressWithLabel;
